export const GET_UPLOADS = "GET_UPLOADS";
export const GET_UPLOAD_BY_ID = "GET_UPLOAD_BY_ID";
export const UPDATE_UPLOAD = "UPDATE_UPLOAD";
export const DELETE_UPLOAD = "DELETE_UPLOAD";
export const CREATE_UPLOAD = "CREATE_UPLOAD";
